module.exports = __webpack_public_path__ + "img/support.e935ad7d.svg";